/*
 * PostHog storefront loader. Included by snippets/posthog.liquid, which passes
 * its configuration as data attributes on the <script> tag:
 *   data-key       PostHog project key (phc_...)
 *   data-host      API host (EU or US cloud)
 *   data-customer  Shopify customer id, empty for guests
 *
 * This lives in an asset instead of inline in the snippet because Theme
 * Check's Liquid-HTML parser cannot parse PostHog's minified loader stub inside
 * a <script> tag (LiquidHTMLSyntaxError), even inside {% raw %}.
 *
 * CONSENT: PostHog starts opted out and captures nothing until Shopify's
 * Customer Privacy API says analytics processing is allowed. It follows the
 * visitor's later choice through `visitorConsentCollected`, in both
 * directions. When the API cannot be loaded, it stays opted out (fails closed).
 *
 * Cart and checkout events are NOT sent from here; they come from the custom
 * web pixel in docs/posthog-web-pixel.js. Adding them here as well counts every
 * cart add twice.
 */
(function () {
  var script = document.currentScript;
  var key = script && script.dataset.key;
  if (!key) return;
  var host = script.dataset.host || 'https://eu.i.posthog.com';
  // Customer id only, never the email: PostHog does not need PII.
  var customerId = script.dataset.customer || '';

  // Official PostHog loader stub (posthog.com/docs/libraries/js), unchanged.
  !function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],Object.defineProperty(u,"toString",{configurable:!0,enumerable:!0,writable:!0,value:function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e}}),Object.defineProperty(u.people,"toString",{configurable:!0,enumerable:!0,writable:!0,value:function(){return u.toString(1)+".people (stub)"}}),o="init capture register register_once register_for_session unregister unregister_for_session getFeatureFlag getFeatureFlagResult isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey getNextSurveyStep identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty createPersonProfile opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing debug".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);

  function applyConsent(ph, allowed) {
    if (allowed) {
      if (!ph.has_opted_in_capturing()) ph.opt_in_capturing();
      if (customerId) ph.identify(customerId);
    } else if (!ph.has_opted_out_capturing()) {
      ph.opt_out_capturing();
    }
  }

  window.posthog.init(key, {
    api_host: host,
    defaults: '2026-05-30',
    person_profiles: 'identified_only',
    opt_out_capturing_by_default: true,
    loaded: function (ph) {
      // A customer logged out, but the cookie still carries their identity.
      // Without this the next visitor on a shared device, including their
      // checkout (the web pixel reads the same cookie), lands on that customer.
      if (!customerId && ph.get_property('$user_state') === 'identified') ph.reset();

      // Later choices from the cookie banner, in both directions.
      document.addEventListener('visitorConsentCollected', function (event) {
        applyConsent(ph, !!(event.detail && event.detail.analyticsAllowed));
      });

      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (error) return; // stays opted out
        var privacy = window.Shopify.customerPrivacy;
        applyConsent(ph, !!(privacy && privacy.analyticsProcessingAllowed()));
      });
    },
  });
})();
